import { render, staticRenderFns } from "./wap.vue?vue&type=template&id=2a4661c6&scoped=true"
import script from "./wap.vue?vue&type=script&lang=js"
export * from "./wap.vue?vue&type=script&lang=js"
import style0 from "../assets/css/wap.css?vue&type=style&index=0&id=2a4661c6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4661c6",
  null
  
)

export default component.exports